module.exports = __webpack_public_path__ + "static/media/32.3e57ebd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/32.svg
// module id = 143
// module chunks = 0